import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import AutoPayment from '../AutoPayment';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window.$environment?.CURRENT_LAYOUT;
const Input = lazy(() => import(`globalcomponents/UI/Input/${layout}`));
const Label = lazy(() => import(`globalcomponents/UI/FormLabel/${layout}`));
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));
const Select = lazy(() => import(`globalcomponents/UI/Select/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`).default;

export default function RightForm({
  Styled,
  values,
  handleEdit,
  showError,
  errors,
  isNotValid,
  hasSaveApiStatus,
  type,
  lossControllers,
  underWriters,
}) {
  const i18n = useTranslation();

  return (
    <Styled.rightSection>
      <div className="cycleruleSection">
        <SubHeader text={i18n.t('companyData.insuranceSettings')} className="subheaderSection companyTitle" variant="h2" />
        <FormStyle.FieldsWrapper>
          <Label htmlFor="underwriterId" variant="body1">
            {i18n.t('companyData.underwriter')}
          </Label>
          <FormStyle.TextWrapper>
            <Field
              name="underwriterId"
              id="underwriterId"
              onChange={(event) => handleEdit(event, { field: 'underwriterId' })}
              as={Select}
              placeholder={i18n.t('common.pleaseSelect')}
              value={values['underwriterId']}
              suggestions={underWriters || []}
            />
            {showError('underwriterId', errors, isNotValid, hasSaveApiStatus?.errorMessage)}
          </FormStyle.TextWrapper>
        </FormStyle.FieldsWrapper>
        <FormStyle.FieldsWrapper>
          <Label htmlFor="lossControlId" variant="body1">
            {i18n.t('companyData.lossControl')}
          </Label>
          <FormStyle.TextWrapper>
            <Field
              name="lossControlId"
              id="lossControlId"
              onChange={(event) => handleEdit(event, { field: 'lossControlId' })}
              as={Select}
              placeholder={i18n.t('common.pleaseSelect')}
              value={values['lossControlId']}
              suggestions={lossControllers || []}
            />
            {showError('lossControlId', errors, isNotValid, hasSaveApiStatus?.errorMessage)}
          </FormStyle.TextWrapper>
        </FormStyle.FieldsWrapper>
        <FormStyle.FieldsWrapper>
          <Label htmlFor="radiusTolerance" variant="body1">
            {i18n.t('common.radiusTolerance')}
          </Label>
          <FormStyle.TextWrapper>
            <Field
              name="radiusTolerance"
              id="radiusTolerance"
              handleOnChange={(event) => handleEdit(event, { field: 'radiusTolerance' })}
              as={Input}
              placeholder={i18n.t('common.radiusTolerance')}
              value={values['radiusTolerance']}
              type="text"
            />
            {showError('radiusTolerance', errors, isNotValid, hasSaveApiStatus?.errorMessage)}
          </FormStyle.TextWrapper>
        </FormStyle.FieldsWrapper>
        {type === 'add' && checkServiceProvider('autoPayment', window.$environment.SERVICE_PROVIDER, false) && (
          <div>
            <SubHeader text={i18n.t('companyData.billingInformation')} className="subheaderSection companyTitle" variant="h2" />
            <AutoPayment {...{ values, handleEdit, showError, errors, isNotValid, hasSaveApiStatus }} />
          </div>
        )}
      </div>
    </Styled.rightSection>
  );
}
